// extracted by mini-css-extract-plugin
export var askAiIcon = "_oc-9";
export var container = "_oc-0";
export var groupSeparator = "_oc-a";
export var highlight = "_oc-4";
export var resultIcon = "_oc-5";
export var resultItem = "_oc-7";
export var resultSubtitle = "_oc-3";
export var resultTitle = "_oc-2";
export var resultsList = "_oc-1";
export var searchGroup = "_oc-6";
export var selected = "_oc-8";